export default function isNumber(variable) {
	return typeof variable === 'number';
}
